import { Box, Typography } from "@mui/material";

import ClientAddressAutoComplete from "../../../../../../ui library/components/address-autocomplete/ClientAddressAutoComplete";
import HNSColors from "../../../../../../ui library/HNSColors";
import QuestionTitle from "../../../components/QuestionTitle";
import sharedStyles from "../styles/formStyles";

import useAddressFieldState from "./hooks/useAddressFieldState";

export default function ClientAddressField({
  label,
  value,
  onChange,
  readOnly = {},
  isRequired = false,
  addressRecord: controlledAddress,
  initialAddress: controlledInitial,
  isEditing: controlledIsEditing,
  setIsEditing: setControlledIsEditing,
  errors: errorsProp,
  hasAddress: controlledHasAddress,
  onAddressChange,
  displayKey,
}) {
  const {
    addressRecord,
    combinedErrors,
    showError,
    handleAddressSelect,
  } = useAddressFieldState({
    value,
    readOnly,
    displayKey,
    isControlled: controlledAddress !== undefined || typeof onAddressChange === "function",
    controlledAddress,
    controlledInitial,
    controlledIsEditing,
    setControlledIsEditing,
    controlledHasAddress,
    isRequired,
    errorsProp,
    onChange,
    onAddressChange,
  });

  return (
    <div className="mb-4 md:col-span-6">
      <QuestionTitle label={label} sx={sharedStyles.label(false)} />
      <Box mt={0.5}>
        <ClientAddressAutoComplete
          address={addressRecord}
          setAddress={handleAddressSelect}
          hideLabel
          containerClassNames="w-full"
          showAddressDetails={false}
          inputSx={{
            ...sharedStyles.textField,
            "& .MuiOutlinedInput-root": {
              ...sharedStyles.textField["& .MuiOutlinedInput-root"],
              "& fieldset": {
                borderColor: showError ? HNSColors.failure[500] : HNSColors.neutrals[400],
              },
            },
          }}
        />
        {showError && (
          <Typography variant="caption" color={HNSColors.failure[500]}>
            {combinedErrors.address}
          </Typography>
        )}
      </Box>
    </div>
  );
}
